import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
// The stock search plugin's `searchApi` extension provides the `searchApiRef`
// implementation (a SearchClient over discovery+fetch). We register just that
// extension — NOT the stock `searchPage` — so the API resolves while our own
// custom `/search` page and command palette own the UI.
import { searchApi } from '@backstage/plugin-search/alpha';
import { Search } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';
import { searchRouteRef } from './routeRefs';

const searchPage = PageBlueprint.make({
  params: {
    path: '/search',
    title: 'Search',
    icon: <Search size={20} strokeWidth={1.75} />,
    routeRef: searchRouteRef,
    noHeader: true,
    loader: () =>
      import('./SearchPage').then(m => (
        <PageShareTitle title="Search">
          <m.SearchPage />
        </PageShareTitle>
      )),
  },
});

export const searchPlugin = createFrontendPlugin({
  pluginId: 'search',
  extensions: [searchPage, searchApi],
  routes: { root: searchRouteRef },
});
